import AddIcon from '@mui/icons-material/Add'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import { Button, Hidden, TextField, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import useUserPermissions from '../../../hooks/useUserPermissions'
import useButtonsStyles from '../../../styles/buttonsStyles'
import useFormsStyles from '../../../styles/formsStyles'
import PageContent from '../../Common/pageContent/PageContent'
import PageContentBody from '../../Common/pageContent/PageContentBody'
import PageContentHeader from '../../Common/pageContent/PageContentHeader'
import NetworkInvite from '../../Network/NetworkInvite'
import useStyles from './_styles'
import PhysicianListFilters from './PhysicianListFilters'
import TokTokDocDataTable from '../../Common/DataTable'
import useCurrentUser from '../../../hooks/useCurrentUser'
import { useListControls } from '../../../hooks/useListControls'
import { useGetIdsHealthcareservicesHcsIdRequiredExperts } from '@toktokdoctech/tokapi-client'
import { useAddLogMutation } from '../../../api/mutations/__generated__/addLog.gql'
import { describeRows, getHeaders } from './_utils'

export default function PhysicianList() {
    const { hasUserPermission } = useUserPermissions()
    const theme = useTheme()
    const large = useMediaQuery(theme.breakpoints.up('sm'))
    const classes = useStyles()
    const formsClasses = useFormsStyles()
    const buttonsClasses = useButtonsStyles()
    const healthCareService = useCurrentHcs()
    const currentUser = useCurrentUser()
    const navigate = useNavigate()

    // TODO: unused for the moment
    // const [filters, setFilters] = React.useState({
    //     statuses: [],
    //     specialities: [],
    // })

    const {
        page,
        search,
        sort,
        itemsPerPage,
        handlePaginationChange,
        handleSearchChange,
        handleItemsPerPageChange,
        handleSort,
    } = useListControls(large ? 10 : 5)

    const { data, isLoading, isError } = useGetIdsHealthcareservicesHcsIdRequiredExperts(healthCareService.id, {
        skip: page * itemsPerPage,
        limit: itemsPerPage,
        search,
    })

    const [sendLog] = useAddLogMutation()

    React.useEffect(() => {
        if (!isLoading && !isError) {
            sendLog({
                variables: {
                    input: {
                        hcsId: healthCareService.id,
                        fromApp: 'IDS',
                        userId: currentUser?.id ?? '',
                        message: `[PhysicianList] Accès liste requis`,
                        logLevel: 'INFO',
                    },
                },
            })
        }
    }, [isLoading, isError, sendLog, healthCareService.id, currentUser?.id])

    // TODO: unused for the moment
    // const handleFiltersChange = (event: any) => {
    //     const { name, value } = event.target
    //     // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    //     const inside = filters[name].indexOf(value)
    //     if (inside !== -1) {
    //         setFilters({
    //             ...filters,
    //             // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    //             [name]: filters[name].filter((role: any) => role !== value),
    //         })
    //         // setPage(0)
    //     } else {
    //         const stuff = {
    //             ...filters,
    //             // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    //             [name]: [...filters[name], value],
    //         }
    //         setFilters(stuff)
    //         // setPage(0)
    //     }
    // }

    // const handleResetFilter = () => {
    //     setFilters({
    //         statuses: [],
    //         specialities: [],
    //     })
    // }

    return (
        <PageContent className={classes.PhysicianList}>
            <PageContentHeader
                left={
                    <>
                        <TextField
                            variant="outlined"
                            id="input-with-icon-adornment"
                            data-cy="input-with-icon-adornment"
                            className={formsClasses.SearchField}
                            onChange={(event) => {
                                const { value } = event.target
                                handleSearchChange(value)
                            }}
                            label={
                                <Typography className={formsClasses.SearchFieldLabel}>
                                    <SearchRoundedIcon />
                                    <span>Recherche par nom et prénom</span>
                                </Typography>
                            }
                        />
                        {/* TOODO: hidden for the moment */}
                        {/* <PhysicianListFilters
                            healthCareService={healthCareService}
                            handleFiltersChange={handleFiltersChange}
                            filters={filters}
                            handleResetFilter={handleResetFilter}
                        /> */}
                    </>
                }
                right={
                    <>
                        {/* TOODO: hidden for the moment */}
                        {/* {hasUserPermission('ADMIN') && (
                            <NetworkInvite
                                refresh={() =>
                                    setFilters({
                                        ...filters,
                                    })
                                }
                            />
                        )} */}
                        {hasUserPermission('ADMIN') && (
                            <Button
                                variant="contained"
                                disableElevation
                                className={buttonsClasses.ButtonBlack}
                                startIcon={<AddIcon />}
                                component={Link}
                                to="/expert"
                                data-cy="expertCreationForm"
                            >
                                <Hidden smDown>Ajouter</Hidden>
                            </Button>
                        )}
                    </>
                }
            />
            <PageContentBody>
                <TokTokDocDataTable
                    loading={isLoading}
                    page={page}
                    itemsPerPage={itemsPerPage}
                    count={data?.total}
                    handlePaginationChange={handlePaginationChange}
                    handleItemsPerPageChange={handleItemsPerPageChange}
                    headers={getHeaders({ sort, handleSort, large })}
                    items={data?.items ?? []}
                    describeRows={(row) => describeRows(row, large)}
                    onRowClick={(row) => {
                        navigate(`/expert/${row?.id}`)
                    }}
                />
            </PageContentBody>
        </PageContent>
    )
}
